import { Helmet } from 'react-helmet-async';

const OG_IMAGE = 'https://kosad.org/images/og-image.jpg';
const SITE_NAME = 'KOSAD';
const BASE_URL = 'https://kosad.org';

export const PageSEO = ({ title, description, path = '/', image }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Kocaeli Sürdürülebilir Arıcılık ve Dayanışma Derneği`;
  const fullUrl = `${BASE_URL}${path}`;
  const ogImage = image || OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
